import {cache} from "./localCache";
export const CARGO_WEIGHT_VOLUME_LISTENER = "cargoWeightVolumeListener";

/**
 * 发送包裹信息事件
 * @param info
 */
export function sendCargoEvent(info) {
  if(cache.outDeviceModel!==3){
    return;
  }
  let event = new Event(CARGO_WEIGHT_VOLUME_LISTENER);
  event.data = info;
  document.dispatchEvent(event);
}

export function sendEvent(eventName,info) {
  let event = new Event(eventName);
  event.data = info;
  document.dispatchEvent(event);
}





// WEBPACK FOOTER //
// ./src/api/eventUtils.js